<div class="marginrl30">
  <div class="contentTop">
    <div class="title">Requests</div>

    <div id="ACDActions">
      <div>
        <button type="button" id="ACDRequest" tabindex="15" class="contentTop-Button" style="width: 182px"
          (click)="router.navigate(['/ACD/CreateRequest'])">Raise New ACD</button>
      </div>
    </div>
  </div>
  <kendo-expansionpanel title="History" class="expansion" (click)="expandCollapseContent()">
    <div>
      <button id="btn1" class="selectbtn" (click)="searchTypeChanged('JobPlan')"
        [ngClass]="{ activebtn: searchType == 'JobPlan' }">
        Job Plan / MWO Header
      </button>
      <button id="btn1" class="selectbtn" (click)="searchTypeChanged('PM')"
        [ngClass]="{ activebtn: searchType == 'PM' }">
        PM
      </button>
      <button id="btn1" class="selectbtn" (click)="searchTypeChanged('EPL')"
        [ngClass]="{ activebtn: searchType == 'EPL' }">
        EPL
      </button>
    </div>

    <div>
      <div class="searchBlock">
        <div class="searchFieldBlock fieldBlock full-width">
          <form [formGroup]="searchForm"  #myForm="ngForm">
            <div class="inputlist">
              <div class="textboxList">
                <div class="inputbox">
                  <p>
                    Tag/s
                    <span #pmtag>
                      <fa-icon [icon]="iconPack.FASEARCHPLUS" (click)="openPopupCheck(pmtag, pmTagText, 'tag')"
                        class="faIcon"></fa-icon>
                    </span>
                  </p>
                  <input type="text" value="" #pmTagText formControlName="tag" (keydown)="OnKeyDown($event)" />
                </div>

                <div class="inputbox" *ngIf="isPMShow">
                  <p>
                    MWO<span #pmMwo><fa-icon [icon]="iconPack.FASEARCHPLUS"
                        (click)="openPopupCheck(pmMwo, pmMWOText, 'mwo')" class="faIcon"></fa-icon></span>
                  </p>
                  <input type="text" value="" #pmMWOText formControlName="mwo" (keydown)="OnKeyDown($event)" />
                </div>

                <div class="inputbox" *ngIf="isPMProbDescShow">
                  <p>MWO Problem Description</p>
                  <input type="text" value="" formControlName="mwoProbDesc" (keydown)="OnKeyDown($event)" />
                </div>

                <div class="inputbox" *ngIf="isJPNumberShow">
                  <p>
                    Job Plan Number<span #JobPlanNumber><fa-icon [icon]="iconPack.FASEARCHPLUS" (click)="
                          openPopupCheck(JobPlanNumber, pmMWOText, 'jobPlanNumber')
                        " class="faIcon"></fa-icon></span>
                  </p>
                  <input type="text" value="" #pmMWOText formControlName="jobPlanNumber"
                    (keydown)="OnKeyDown($event)" />
                </div>

                <div class="inputbox" *ngIf="isEPLShow">
                  <p>
                    EPL Short<span #eplShort><fa-icon [icon]="iconPack.FASEARCHPLUS"
                        (click)="openPopupCheck(eplShort, eplShortText, 'eplShort')" class="faIcon"></fa-icon></span>
                  </p>
                  <input type="text" value="" #eplShortText formControlName="eplShort" (keydown)="OnKeyDown($event)" />
                </div>

                <div class="inputbox" *ngIf="isEPLShow">
                  <p>
                    EPL Long<span #eplLong><fa-icon [icon]="iconPack.FASEARCHPLUS"
                        (click)="openPopupCheck(eplLong, eplLongText, 'eplLong')" class="faIcon"></fa-icon></span>
                  </p>
                  <input type="text" value="" #eplLongText formControlName="eplLong" (keydown)="OnKeyDown($event)" />
                </div>

                <div class="inputbox" *ngIf="isEPLShow">
                  <p>
                    Item<span #eplItem><fa-icon [icon]="iconPack.FASEARCHPLUS"
                        (click)="openPopupCheck(eplItem, eplItemText, 'item')" class="faIcon"></fa-icon></span>
                  </p>
                  <input type="text" value="" #eplItemText formControlName="item" (keydown)="OnKeyDown($event)" />
                </div>
              </div>
            </div>
          </form>

          <div class="actionSection">
            <div class="submitButton">
              <input type="submit" id="btn1" value="{{btnActionName}}" class="searchBtn" (click)="historyApiClick()"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </kendo-expansionpanel>

  <app-grid [setGridData]="gridData"></app-grid>
</div>

<kendo-popup id="BulkSearch" [anchor]="anchorElement" [animate]="true" *ngIf="show">
  <div class="popupDialog">
    <div class="popupHeader">
      <span class="popupTitle" id="popupTitle">Bulk Search</span>
      <div href="#" class="popupClose" role="button" tabindex="0">
        <fa-icon [icon]="closeIcon" (click)="closePopup()" class="popupCLoseIcon"></fa-icon>
      </div>
    </div>
    <div class="popupContent">
      <div>
        <kendo-textarea class="popuptextBox" (valueChange)="onValueChange($event)" [value]="Inputvalue"
          [maxlength]="3500" #bulksearchtextarea [style.max-height.px]="180"
          placeholder="Paste text here.. (One entry per line )"></kendo-textarea>
      </div>
      <div class="popupFunctions">
        <kendo-label class="characterCount">Characters left : {{ counter
          }}<span *ngIf="!remainingCharacter"> reached limit</span></kendo-label>
        <button type="submit" class="primarybtn" (click)="popupSubmit()">
          Submit
        </button>
      </div>
    </div>
  </div>
</kendo-popup>